var process = (typeof require != "undefined") ? require("process") : false;
var exec = (typeof require != "undefined") ? require('child_process').exec : false;
var gui = (typeof require != "undefined") ? require('nw.gui') : false;
var fs = (typeof require != "undefined") ? require('fs') : false;
var dirname = (typeof require != "undefined") ? require('./util.js').dirname : false;

var localStorageName = "current-video-" + 8;

var numVideosWide = 6;
var numVideosHeight = 3;
var numScreens = 2;

var DEBUG = false;

// Constructor
function App(type) {
	this.type = type;

	// this.currentVideo = numScreens * numVideosWide * numVideosHeight;

	if (this.type == "camera") {

		console.log("DEBUG MODE IS : ", DEBUG);

		if (DEBUG) {
			// reset localstorage if debug is on. Prevents to have to do it manually each build
			localStorage.removeItem(localStorageName);
		}

		this.camera = false;
		this.data = false;
		this.recorder = false;
		this.bridge = new Bridge(this);

		if (localStorage.getItem(localStorageName) == null) {
			localStorage.setItem(localStorageName, numScreens * numVideosWide * numVideosHeight);
		}

		this.$loading;

		this.isExperience = false;
		this.$loading = jQuery("#loading");

		this.secondWindow = false;

		this.init();

		// Open second window
		if (typeof nw !== "undefined") {
			nw.Window.open('wall.html', {
				frame: false,
				always_on_top: false,
				width: 1920 * numScreens,
				height: 1080,
				min_width: 1920 * numScreens,
				min_height: 1080
			}, $.proxy(function (win) {

				// save value
				this.secondWindow = win;

				// Trigger replace window
				setInterval($.proxy(this.replaceWindow, this), 5000);
				this.replaceWindow();

			}, this));

		}
	} else if (this.type == "wall") {
		this.wall = new Wall(this);
	}

	return this;
}

App.prototype.replaceWindow = function () {

	if (this.secondWindow != false) {
		this.secondWindow.moveTo(1080, 0);
	} else {
		console.log("no nwjs window");
	}
}


App.prototype.loadData = function (dataPath, callback) {
	jQuery.getJSON(dataPath, jQuery.proxy(function (data) {
		this.data = data;
		this.loadShaders(callback);
	}, this));
}

App.prototype.loadShaders = function (callback) {

	var shaders = [];
	var shadersLoaderCount = 0;
	var shadersHolder = {vertex: '', fragment: ''};

	jQuery('script[type="x-shader/x-fragment"], script[type="x-shader/x-vertex"]').each(function (i, elem) {
		var type = jQuery(elem).attr('type');
		shaders.push({
			id: i,
			src: jQuery(elem).data('src'),
			name: jQuery(elem).data('name'),
			type: (type == 'x-shader/x-fragment') ? "fragment" : "vertex",
		});
		shadersLoaderCount++;
	});

	jQuery.each(shaders, function (i, el) {

		jQuery.ajax({
			url: el.src,
			dataType: 'text',
			context: {
				name: el.name,
				type: el.type
			},
			complete: function (jqXHR, textStatus) {
				shadersLoaderCount--;
				shadersHolder[el.type] = jqXHR.responseText;
				if (!shadersLoaderCount) {
					callback(shadersHolder);
				}
			}
		});
	});
}

App.prototype.init = function (shaders, fallback) {
	this.$loading.removeClass("shown");

	this.camera = new Camera(this);

	this.initExperience();
}

App.prototype.initRecorder = function (stream) {
	this.recorder = new Recorder(this, stream);
}

// Launch experience
App.prototype.initExperience = function () {

	// show loading
	this.$loading.addClass("shown");

	this.startExperience();
}

App.prototype.startExperience = function () {

	// hide loading
	this.$loading.removeClass("shown");
	console.log("experience start");
	this.isExperience = true;
	this.camera.play();
	window.addEventListener("keydown", $.proxy(this.keydown, this));
}

App.prototype.keydown = function (e) {
	if (this.type == "camera") {

		// space
		if (e.keyCode == 32) {
			localStorage.setItem('reset-wall', 1);
		}
	}
}


App.prototype.click = function (e) {
}


App.prototype.mousemove = function (e) {
}

App.prototype.recordingCompleted = function (num) {
	localStorage.setItem(localStorageName, num);

	var tween = TweenMax.to(this.camera.videoEl, 1, {
		scaleX: 0,
		scaleY: 0,
		ease: Back.easeIn.config(3),
		onComplete: $.proxy(function () {

			TweenMax.fromTo(this.camera.videoEl, 1, {
				opacity: 0,
				scaleX: 1,
				scaleY: -1,
			}, {
				opacity: 1,
				scaleX: 1,
				scaleY: -1,
				ease: Back.easeIn.config(3),
				onComplete: $.proxy(function () {

					// reactivate state
					$('body').removeClass("recording");
					this.recorder.recording = false;

				}, this)
			});


		}, this)
	});
}

// Toggle fullscreen mode
App.prototype.toggleFullScreen = function (e) {

	if ((document["fullScreenElement"] && document["fullScreenElement"] !== null) || (!document["mozFullScreen"] && !document["webkitIsFullScreen"])) {
		if (document.documentElement.requestFullscreen) {
			document.documentElement.requestFullscreen();
		} else if (document.documentElement["msRequestFullscreen"]) {
			document.documentElement["msRequestFullscreen"]();
		} else if (document.documentElement["mozRequestFullScreen"]) {
			document.documentElement["mozRequestFullScreen"]();
		} else if (document.documentElement["webkitRequestFullscreen"]) {
			document.documentElement["webkitRequestFullscreen"]();
		}

	} else {
		if (document["cancelFullScreen"]) {
			document["cancelFullScreen"]();
		} else if (document["mozCancelFullScreen"]) {
			document["mozCancelFullScreen"]();
		} else if (document["webkitCancelFullScreen"]) {
			document["webkitCancelFullScreen"]();
		}
	}
}

// Expose App
window.App = App;